(function () {
  'use strict';

  angular.module('app.admin.common').controller('AdminHeaderController', AdminHeaderController);

  function AdminHeaderController() {}
})();
